module.exports = __webpack_public_path__ + "img/finland.dd5c04dc.png";